/* Окно подтверждения (`Dialog`): высота не больше экрана минус отступы, тело
   прокручивается, заголовок и кнопки остаются на месте. Чинит «окно съело экран»
   везде, где `Dialog` уже подключён; пропсы и разметка не менялись.
   Селектор длиннее, чем в ui.css, — порядок подключения файлов не важен. */
.ui-dialog-overlay .ui-dialog-card {
  max-height: calc(100dvh - 2 * var(--sp-4));
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
}

.ui-dialog-overlay .ui-dialog-card__body {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}
